import React from "react";
import { StatusBadge } from "./StatusBadge";
import { styles } from "./styles";
import { SSHErrorCode } from "../../types/ssh-errors";

interface TerminalHeaderProps {
  appName: string;
  projectName: string;
  isConnected: boolean;
  isReconnecting?: boolean;
  connectionError: string | null;
  errorCode?: SSHErrorCode;
  sessionClosed?: boolean;
  isOnline: boolean;
  isDarkMode: boolean;
  onToggleTheme: () => void;
}

export const TerminalHeader: React.FC<TerminalHeaderProps> = ({
  appName,
  projectName,
  isConnected,
  isReconnecting,
  connectionError,
  errorCode,
  sessionClosed,
  isOnline,
  isDarkMode,
  onToggleTheme,
}) => {
  return (
    <div style={styles.header(isDarkMode)} className="terminal-header">
      <div style={styles.headerLeft} className="terminal-header-left">
        <div style={styles.titleGroup} className="terminal-title-group">
          <h1 style={styles.title(isDarkMode)} className="terminal-title">
            {appName}
          </h1>
          <span
            style={styles.subtitle(isDarkMode)}
            className="terminal-subtitle"
          >
            {projectName}
          </span>
        </div>
        <StatusBadge
          isConnected={isConnected}
          isReconnecting={isReconnecting}
          connectionError={connectionError}
          errorCode={errorCode}
          sessionClosed={
            sessionClosed ?? errorCode === SSHErrorCode.SESSION_NOT_FOUND
          }
          isOnline={isOnline}
        />
      </div>

      <div style={styles.buttonGroup} className="terminal-button-group">
        <button
          style={styles.iconButton(isDarkMode)}
          className="terminal-icon-button"
          onClick={onToggleTheme}
          title={isDarkMode ? "Light Mode" : "Dark Mode"}
        >
          <span style={{ fontSize: "14px" }}>{isDarkMode ? "☀️" : "🌙"}</span>
        </button>
      </div>
    </div>
  );
};
